import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";

interface DeleteConfirmationModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    itemLabel: string;
    itemName?: string;
    isDeleting?: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
    show,
    onHide,
    onConfirm,
    title,
    message,
    itemLabel,
    itemName = "",
    isDeleting = false,
}) => {
    const { t } = useTranslation("common");
    const handleConfirm = () => {
        onConfirm();
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            // size="md" -> will result in medium size -> otherwise pick other sizes (mheicke)
            backdrop="static"
            keyboard={false}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="text-danger">⚠️ {title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-3">{message}</p>
                {itemName && (
                    <div className="alert alert-warning">
                        <strong>{itemLabel}</strong> {itemName}
                    </div>
                )}
                <p className="text-muted small mb-0">
                    <strong>{t("delete.warningPrefix")}</strong> {t("delete.warning")}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={isDeleting}>
                    {t("buttons.cancel")}
                </Button>
                <Button variant="danger" onClick={handleConfirm} disabled={isDeleting}>
                    {isDeleting ? (
                        <>
                            <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            {t("delete.deleting")}
                        </>
                    ) : (
                        t("buttons.delete")
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteConfirmationModal;
